module.exports = __webpack_public_path__ + "static/media/hiw_1.84c1f362.svg";